import { TiDeleteOutline, TiEdit } from "react-icons/ti";

import { Fonts } from "Themes/Fonts";
import { Metrics } from "Themes/Metrics";
import styled from "styled-components";

export const SideProjectsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  border-radius: 5px;
  padding: 10px;
  justify-content: center;
`;

export const SideProject = styled.div`
  border: solid 2px black;
  border-radius: 5px;
  margin: 20px;
  width: 200px;
  height: 300px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  &: hover {
    opactiy: 0.5;
  }
`;

export const Link = styled.div`
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;

export const EditIcon = styled(TiEdit)``;

export const DeleteIcon = styled(TiDeleteOutline)``;

export const IconContainer = styled.div`
  display: none;
  border: solid 2px lightgray;
  border-radius: 10px;
  padding: 10px;
  background-color: white;
`;

export const SideProjectImage = styled.div`
  border: solid 3px lightgray;
  border-radius: 300px;
  height: 150px;
  width: 150px;
  margin: 0px 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  &:hover {
    opacity: 0.7;
  }
  &:hover ${IconContainer} {
    opactiy: 1;
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    border: solid 2px black;
  }
`;

const styles = {
  mainContainer: {
    ...Metrics.mainContainer
  },
  personalDetailsContainer: {
    display: "flex",
    width: "70%",
    margin: "auto",
    marginBottom: Metrics.margin.small,
    borderBottom: "solid 2px lightgrey",
    paddingBottom: Metrics.padding.small
  },
  personalDetails: {
    width: "100%"
  },
  personalDetailsImage: {
    flex: 1
  },
  personalDetailsText: {
    flex: 4
  },
  firstName: {
    fontSize: Fonts.fontSize.large
  },
  profileAvatar: {
    height: "150px",
    width: "150px"
  },
  sendMessageIcon: {
    height: "50px",
    width: "50px",
    cursor: "pointer"
  }
};

export default styles;
